import Vue from 'vue';
import axios from 'axios';
import { eventHub } from '@/utils/EventHub';
import { SilentUrls } from '../constants/Constants';

const baseURL = process.env.VUE_APP_API_BASE_URL;

const instance = axios.create({
  baseURL,
  withCredentials: true
});

instance.interceptors.request.use(
  conf => {
    if (!SilentUrls.includes(conf.url)) {
      eventHub.$emit('before-request');
    }
    return conf;
  },
  error => {
    eventHub.$emit('request-error');
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  response => {
    // console.log(response.request.responseURL)
    // const len = response.request.responseURL.length;
    // const url = response.request.responseURL.substring(baseURL.length - 1, len);
    eventHub.$emit('after-response');
    return response;
  },
  error => {
    try {
      const originalRequest = error.config;

      // If response is 401 emmits an event that logout user
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        eventHub.$emit('auth-error');
      }
      else if(error.response.status === 429) { // If response was 429 emits an event to show 429 view
        eventHub.$emit('too-many-requests');
        return Promise.reject(new Error('http_error_429'));
      }
      else eventHub.$emit('response-error');
      return Promise.reject(error);
    } catch (error) {
      /* If an error is catched here could mean BackEnd is dead,
        so if client want to block user navigation at the very instant
        that axios knows server is not responding, then
        you have to uncomment 2 lines of this event in App.vue/handle5xxErr */
      eventHub.$emit('server-error');
      return Promise.reject(new Error('server_error'));
    }
  }
);
Vue.prototype.$axios = instance;
